import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tile-selector" }
const _hoisted_2 = ["onClick"]


export default /*@__PURE__*/_defineComponent({
  __name: 'TileSelector',
  props: {
  items: {
    type: Array,
    required: true,
  },

  labelProperty: {
    type: String,
    default: null,
  },
},
  emits: ['click'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `item-${i}`,
        class: "tile-selector-item",
        onClick: ($event: any) => (_ctx.$emit('click', item))
      }, _toDisplayString(__props.labelProperty ? item[__props.labelProperty] : item), 9, _hoisted_2))
    }), 128))
  ]))
}
}

})